import { ApiUrl } from "../ApiUrl";
import api, { makeQueryParams } from "../ApiService";

export const fetchPagePermissions = async (
  obj: {
    page: number,
    pageSize: number,
    search: string,
    sort_by: string,
    division_id: string}
) => {
  const response = await api.get(
    `${ApiUrl.pagePermissionModule.common_base}${makeQueryParams(obj)}`
  );
  return response;
};

export const fetchPermissionForUser = async (pagePermissionId: string) => {
  const response = await api.get(
    `${ApiUrl.pagePermissionModule.common_base}${pagePermissionId}/retrieve_page_level_permission/`
  );
  return response;
};

export const updatePagePermissionForUser = async (
  pagePermissionId: string,
  payload: object
) => {
  const response = await api.put(
    `${ApiUrl.pagePermissionModule.common_base}${pagePermissionId}/`,
    payload
  );
  return response;
};
